﻿/* globals ModalAvisameDTO*/
require('tooltipster');
var jquery = require('jquery');
var WindowModal = require('../../Global/window-modal');
var HabEvents = require('../../Global/habitaclia-events');
var Functions = require('./functions');

(function() {
    'use strict';

    var ModalAvisame = function (modalAvisameDTO) {
        this.__modalAvisameDTO = modalAvisameDTO;
        this.__$lnkAvisame = jquery('#linkAlerta');
        this.sFooterButtons;
        this.iModalType = 1;
        
        __bindModalEvent.call(this);
    };
    var __bindModalEvent = function(){
        var self = this;

        jquery('.js-notify').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.event = e;
            var modalType = e.currentTarget.getAttribute('data-modalType');
            self.iModalType = parseInt(modalType, 10);
            if (self.__modalAvisameDTO.dataSource === "listado") {
                var dataTarget = jquery(e.currentTarget).data();
                self.__modalAvisameDTO.codigoEmpresa = dataTarget.ce;
                self.__modalAvisameDTO.codigoOficina = dataTarget.co;
                self.__modalAvisameDTO.codigoProducto = dataTarget.ci;
                self.__modalAvisameDTO.codigoAnuncio = dataTarget.codanuncio;
                self.__modalAvisameDTO.tipoOperacion = dataTarget.tipop;
                self.__modalAvisameDTO.tipInm = dataTarget.tipinm;
            }
            if (modalType === '0') {
                self.sFooterButtons = '<div id="buttonIni"><input type="button" id="idBtnSubmit" name="idBtnSubmit" class="boton" value="'
                    + self.__modalAvisameDTO.Translate.AcceptAlerts
                    + '" /> o <a id="idBtnCancelar" title="'
                    + self.__modalAvisameDTO.Translate.Cancel + '">'
                    + self.__modalAvisameDTO.Translate.Cancel + '</a></div></div><div id="buttonEnd" style="display:none;"><input type="button" value="'
                    + self.__modalAvisameDTO.Translate.Close + '" id="idBtnClose" name="idBtnClose" class="boton closeModal"></div>';
            } else {
                jquery(self.event.currentTarget).attr('class', 'js-notify notify notify-orange');
                self.sFooterButtons = '<div id="buttonIni"><input type="button" id="idBtnSubmit" name="idBtnSubmit" class="boton" value="'
                    + self.__modalAvisameDTO.Translate.ConfirmationAlerts
                    + '" /> o <a id="idBtnCancelar" title="'
                    + self.__modalAvisameDTO.Translate.Cancel + '">'
                    + self.__modalAvisameDTO.Translate.Cancel + '</a></div><div id="buttonEnd" style="display:none;"><input type="button" value="'
                    + self.__modalAvisameDTO.Translate.Close + '" id="idBtnClose" name="idBtnClose" class="boton closeModal"></div>';
            }

            jquery.ajax({
                url: self.__modalAvisameDTO.UrlAjaxModalAvisame,
                data: ({
                    idioma: self.__modalAvisameDTO.idioma,
                    codEmp: self.__modalAvisameDTO.codigoEmpresa,
                    codOfi: self.__modalAvisameDTO.codigoOficina,
                    codInm: self.__modalAvisameDTO.codigoProducto,
                    codAnuncio: self.__modalAvisameDTO.codigoAnuncio,
                    p: self.__modalAvisameDTO.parametroP,
                    tipOp: self.__modalAvisameDTO.tipoOperacion,
                    tipInm: self.__modalAvisameDTO.tipInm,
                    st: self.__modalAvisameDTO.parametroSt,
                    codPais: self.__modalAvisameDTO.Geo.codPais,
                    codProv: self.__modalAvisameDTO.Geo.codProv,
                    codCom: self.__modalAvisameDTO.Geo.codCom,
                    codArea: self.__modalAvisameDTO.Geo.codArea,
                    codPob: self.__modalAvisameDTO.Geo.codPob,
                    codDist: self.__modalAvisameDTO.Geo.codDist,
                    codZona: self.__modalAvisameDTO.Geo.codZona,
                    filterPVP: self.__modalAvisameDTO.FilterData.pvpMax,
                    filterSup: self.__modalAvisameDTO.FilterData.supMin,
                    filterHab: self.__modalAvisameDTO.FilterData.numHab,
                    numElements: self.__modalAvisameDTO.numElements,
                    modalType: self.iModalType
                }),
                success: function (result) {
                    
                    jquery.publish(HabEvents.EventsEnum.RegistroAlertaCriterioInmueble); 

                    if (result === 'Alerta eliminada') {
                        /*var action = 'addAlInm';
                        if (typeof addOrRemoveCookieFav === 'function') {
                            addOrRemoveCookieFav(action, codEmp, codInm);
                        }*/
                       
                        if (self.__modalAvisameDTO.dataSource === 'lista' || self.__modalAvisameDTO.dataSource === 'minisite') {
                            self.__$lnkAvisame.attr('class', 'js-notify botongrisbasico avisame sprite notify notify-grey');
                            self.__$lnkAvisame.removeAttr('title');
                        }
                        else if (self.__modalAvisameDTO.dataSource === 'ficha') {
                            jquery('.estimu-alerta-fotos1').removeClass('ocultar');
                            jquery('#alertaspostfotos').removeClass('ocultar');
                            self.__$lnkAvisame.removeAttr('title');
                            self.__$lnkAvisame.tooltipster({ contentCloning: true });
                            jquery('#js-txt-avisamesi').text(self.__modalAvisameDTO.Translate.TextoAvisameSi);
                            self.__$lnkAvisame.attr('class', 'js-notify botongrisbasico avisame sprite notify notify-grey');

                        }
                        if(self.__modalAvisameDTO.UserIsLogged === 'True'){
                            modalType = 1;
                        }else{
                            modalType = 0;
                        }
                        self.iModalType = parseInt(modalType, 10);
                    }
                    else {
                        if (self.__modalAvisameDTO.UserIsLogged==="True" && self.__modalAvisameDTO.dataSource === "listado") {
                            self.event.currentTarget.classList.add('list-notify-active');
                        }
                        __createModalAvisame.call(self, result);
                    }

                    jquery('.jq-tooltip').tooltipster({contentCloning: true});
                }
            });
            
        });
    };

    var __createModalAvisame = function(sHTML) {
        var self = this;
        var oDialog = new WindowModal();
        oDialog.OnReady(function () {
            __bindEventsModalAvisame.call(self);
        });
        oDialog.OnDestroy(__unbindEventsModalAvisame);
        oDialog.CreateWindowModal({
            idSelectorString: 'js-alert-detail',
            focusOn: 'email_FormAlerta',
            dataTitle: '<div class="titleModal">' + self.__modalAvisameDTO.Translate.InboxAlert + '</div><div class="closeModal"></div>',
            dataBody: sHTML,
            dataFooter: this.sFooterButtons,
            modalWidth: '465px',
            modalOverflowY: 'hidden',
            bodyOverflowY: 'hidden'
        });
        if (sHTML.indexOf('TypeModal="0"') > 0) {
            this.iModalType = 0;

        }
        if (this.iModalType === 1) {
            this.iModalType = -1;


            if (this.__modalAvisameDTO.dataSource === 'lista' || this.__modalAvisameDTO.dataSource === 'minisite') {
                self.__$lnkAvisame.attr('class', 'botongrisbasico des avisame sprite modalAvisame');
                self.__$lnkAvisame.attr('title', this.__modalAvisameDTO.Translate.DeleteAlert);
                self.__$lnkAvisame.tooltipster({ contentCloning: true });
            }
            else if (this.__modalAvisameDTO.dataSource === 'ficha') {
                jquery('.estimu-alerta-fotos1').addClass('ocultar');
                jquery('#alertaspostfotos').addClass('ocultar');
                //jquery('#' + self.__idLnkAlerta).attr('class', 'botongrisbasico avisameselect sprite modalAvisame');
                jquery('.addfav').attr('class', 'favorito sprite removefav');
                jquery('.removefav').attr('title', this.__modalAvisameDTO.Translate.DeleteFav);
                self.__$lnkAvisame.attr('title', this.__modalAvisameDTO.Translate.DeleteAlert);
                jquery('#js-txt-avisamesi').text('');
                self.__$lnkAvisame.tooltipster({ contentCloning: true });
            }

            jquery('#idMasMenuFavoritosCount').attr('data-counter', jquery('#numFavs').val());
        }

    };
    var __bindEventsModalAvisame = function() {
        var self = this;
        jquery('#idBtnCancelar, .closeModal').on('click', function () {
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
            __unbindEventsModalAvisame.call(self);
        });
        jquery('#js-alert-detail .jqLinkAvisoLegalUsuarios').on('click', function () {
            jquery('#js-alert-detail #idBtnCancelar').click();
            jquery('body').data('m-avisame-codanuncio', self.sCodAnuncio);
            jquery('.jqLinkAvisoLegalUsuarios').eq(0).click();
        });
        jquery('#js-alert-detail .js-legal-aviso-link').on('click', function () {
            jquery('#js-alert-detail #idBtnCancelar').click();
            jquery('body').data('m-avisame-codanuncio', self.sCodAnuncio);
            jquery('.js-legal-aviso-link').eq(0).click();
        });
        jquery('#idCheckLista').on('change', function () {
            if (jquery(this).prop('checked')) {
                jquery('#allAds').prop('checked', true).parent().addClass('strong');
            }
            else {
                jquery('.alertaFilters input:radio').prop('checked', false).parent().removeClass('strong');
            }
        });
        jquery('input:radio[name=filtros_alerta]').on('change', function () {
            jquery('#idCheckLista').prop('checked', true);
            if (this.id === 'allAds') {
                jquery(this).parent().addClass('strong');
                jquery('#filteredAds').parent().removeClass('strong');
                jquery('#soloON_alerta').parent().removeClass('strong');
            } else {
                jquery(this).parent().addClass('strong');
                jquery('#allAds').parent().removeClass('strong');
            }
        });
        jquery('#js-alert-detail #idBtnSubmit').on('click', function () {
            jquery('#email_FormAlerta').removeClass('error');
            var isLegalChecked = jquery('#idCheckLegalModal').prop('checked');
            var isValidMail = Functions.ValidateEmail(document.getElementById('email_FormAlerta'));
            if (isValidMail && (isLegalChecked || self.__modalAvisameDTO.UserIsLogged ==="True" )) {
                jquery('.errorAlerta').empty();
                jquery('.errorAlerta').removeClass('mensaje stop');
                jquery('.errorAlerta').hide();
                var bRegAlertaFromModal = jquery('#idCheckLista').prop('checked');
                var jForm = jquery('#frmDades');
                jquery.post(self.__modalAvisameDTO.UrlRegistrarAlertaInmueble + '?fromModal=1&bolRegAlertaFromModal=' + bRegAlertaFromModal, jForm.serialize(), function (data) {
                    if (data.status === 0) {
                        jquery('#alertaInfo').hide();
                        jquery('#alertaResultOk').show();
                        jquery('#wmContent').css('height', '200px');
                        jquery('#wmBody').css('height', '85px');
                        jquery('#idMasMenuFavoritosCount').attr('data-counter', data.favoritos);
                        jquery.publish(HabEvents.EventsEnum.RegistroAlertaCriterioListado);
                    } else {
                        jquery('#alertaInfo').hide();
                        jquery('#alertaResultKo').show();
                    }
                    jquery('#wmFooter #buttonIni').hide();
                    jquery('#wmFooter #buttonEnd').show();
                }, 'json');
            } else if (!isValidMail) {
                jquery('.errorAlerta').addClass('mensaje stop');
                jquery('.errorAlerta').text(self.__modalAvisameDTO.Translate.EmailObligatory);
                jquery('.errorAlerta').show();
                jquery('#email_FormAlerta').addClass('error');
                jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-ficha_dialog_avisame', 'Email incorrecto o no informado']); 
            }else if (!isLegalChecked) {
                jquery('.errorAlerta').addClass('mensaje stop');
                jquery('.errorAlerta').text(self.__modalAvisameDTO.Translate.LegalObligatory);
                jquery('.errorAlerta').show();
            } 
        });
        //jquery('.toolTipAvisame').attr('title', '').tooltip({ position: { my: 'right bottom-30', at: 'right bottom', collision: 'flipfit' }, content: jquery('#tooltipAdContent').html() });
        //jquery('.toolTipAvisameSimilares').attr('title', '').tooltip({ position: { my: 'right bottom-30', at: 'right bottom', collision: 'flipfit' }, content: jquery('#tooltipSimilarAdContent').html() });
    };

    var __unbindEventsModalAvisame = function() {
        jquery('#idBtnCancelar, .closeModal').off('click');
        jquery('#js-alert-detail .jqLinkAvisoLegalUsuarios').off('click');
        jquery('#js-alert-detail .js-legal-aviso-link').off('click');
        jquery('#js-alert-detail #idBtnSubmit').off('click');
        jquery('input:radio[name=filtros_alerta]').off('change');
    };

    ModalAvisame.prototype = {
        constructor: ModalAvisame
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = new ModalAvisame(ModalAvisameDTO);
    }
    else {
        window.ModalAvisame = ModalAvisame;
    }
}());